"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OrderChanger;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_order-changer.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function withNoEventPropagation(fn) {
  return function (e) {
    e.preventDefault();
    e.stopPropagation();
    fn();
  };
}

function OrderChanger(_ref) {
  var disabled = _ref.disabled,
      currentIndex = _ref.currentIndex,
      numberOfItems = _ref.numberOfItems,
      onChangeOrder = _ref.onChangeOrder;
  return _react.default.createElement("div", {
    className: "campaign-order-changer"
  }, _react.default.createElement(_uiKit.Icon, {
    name: "arrowup",
    color: currentIndex === 0 || disabled ? 'russian' : 'regent',
    hoverColor: currentIndex === 0 || disabled ? 'russian' : 'monkey',
    size: 15,
    onClick: currentIndex !== 0 && !disabled ? withNoEventPropagation(function () {
      return onChangeOrder(currentIndex, currentIndex - 1);
    }) : null
  }), _react.default.createElement(_uiKit.Icon, {
    name: "arrowdown",
    color: currentIndex === numberOfItems - 1 || disabled ? 'russian' : 'regent',
    hoverColor: currentIndex === numberOfItems - 1 || disabled ? 'russian' : 'monkey',
    size: 15,
    onClick: currentIndex !== numberOfItems - 1 && !disabled ? withNoEventPropagation(function () {
      return onChangeOrder(currentIndex, currentIndex + 1);
    }) : null
  }));
}